import { PortalActions } from '../../constants/actions';
export var FETCH_PORTAL_DATA_FULFILLED = PortalActions.FETCH_PORTAL_DATA + "/fulfilled";
